import { useHydrated } from 'remix-utils/use-hydrated'

import sharedDefaults from '~/shared/shared.defaults.json'
import { Environment } from '~/shared/types/environment'

export const isOnPrem = () => typeof window !== 'undefined' && window?.['ENV']?.env === Environment.ON_PREM

export const useHostname = () => {
  const isHydrated = useHydrated()
  const hostname = isHydrated && isOnPrem() ? window.location.hostname?.split('.')?.slice(1)?.join('.') : sharedDefaults.portalHost
  return hostname
}
